import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  type UndecoratedUser,
  type UpdateCurrentUserResponse,
} from '@flemingmetrics/api-client';

type CurrentUserState = UndecoratedUser | null;

const initialState = null satisfies CurrentUserState as CurrentUserState;

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser: (
      state,
      action: PayloadAction<UpdateCurrentUserResponse>
    ) => {
      return action.payload.user;
    },
  },
});

export const { setCurrentUser } = currentUserSlice.actions;

export default currentUserSlice.reducer;
